import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.makeUrl('/')],
  config: {
    screens: {
      Auth: {
        SignIn: 'signin',
        SignUp: 'signup',
      },
      Splash: 'splash',
      Main: {
        FanRoot: {
          screens: {
            ListenTab: {
              screens: {
                ListenScreen: 'listen',
              },
            },
            ProfileTab: {
              screens: {
                ProfileScreen: 'profle',
              },
            },
          },
        },
        ArtistRoot: {
          screens: {
            TabOne: {
              screens: {
                TabOneScreen: 'one',
              },
            },
            TabTwo: {
              screens: {
                TabTwoScreen: 'two',
              },
            },
          },
        },
        NotFound: '*',
      },
    },
  },
};
